import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IAlmacen} from '../modelos/IAlmacen';

@Injectable({
  providedIn: 'root'
})
export class AlmacenService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtenerTodo(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.almacen.obtenerTodo
    );
  }
}
